/** Service Desk console: mga Order, Quote, Approval at detalye ng order (SD-S2-21, WP-S2-H). */
export const serviceOrders = {
  title: "Mga Order",
  subtitle: "Mga order na ginawa sa chat at web app, o ng staff para sa kliyente, na isinusulat pabalik sa order system mo. May sarili silang tab ang mga quote at approval.",
  tabs: { label: "Mga seksyon ng order", orders: "Mga Order", quotes: "Mga Quote", approvals: "Mga Approval" },
  actions: {
    newOrder: "Bagong order para sa kliyente",
    newQuote: "Bagong quote",
    retry: "I-retry ang sync",
    retryFor: "I-retry ang sync ng {{number}}",
    retryNow: "I-retry ngayon",
    markPlaced: "Markahang naka-place na may reference",
    markPlacedFor: "Markahang naka-place ang {{number}} na may reference",
    cancel: "Kanselahin ang order",
    reject: "Tanggihan ang order",
    refresh: "I-refresh",
  },
  status: {
    draft: "Draft",
    pending_confirmation: "Naghihintay ng kumpirmasyon",
    pending_approval: "Naghihintay ng approval",
    approved: "Aprubado",
    submitting: "Ipinapadala",
    placed: "Naka-place",
    processing: "Pinoproseso",
    partially_shipped: "Bahagyang naipadala",
    shipped: "Naipadala",
    delivered: "Naihatid",
    completed: "Kumpleto",
    declined: "Tinanggihan",
    cancel_requested: "Hiniling na kanselahin",
    cancelled: "Kinansela",
    rejected: "Tinanggihan",
    sync_failed: "Nabigo ang sync",
  },
  quoteStatus: { requested: "Naghihintay ng presyo", quoted: "May quote na", accepted: "Tinanggap", declined: "Tinanggihan", expired: "Nag-expire", converted: "Naging order" },
  approvalStatus: { pending: "Naghihintay ng approval", approved: "Aprubado", declined: "Tinanggihan", expired: "Nag-expire", withdrawn: "Binawi" },
  approvalReason: {
    contact_limit: "Lampas sa sariling limit ng contact",
    org_threshold: "Lampas sa threshold ng organisasyon",
    staff_threshold: "Lampas sa staff approval threshold",
    credit_status: "May credit hold ang organisasyon",
    line_category: "Produktong laging nangangailangan ng approval",
    anomaly: "Hindi karaniwang laki para sa organisasyong ito",
  },
  source: { cart: "Kliyente", staff: "Staff para sa kliyente" },
  stock: { in_stock: "May stock", low: "Kaunti na ang stock", out: "Ubos na", made_to_order: "Gawa kapag inorder" },
  actor: { contact: "Ang kliyente", staff: "Isang miyembro ng team", system: "Sagot" },
  stats: {
    label: "Kabuuan ng mga order",
    attention: "Kailangan ng aksyon",
    attentionHint: "nabigong sync, naghihintay ng approval o hiling na kanselahin",
    active: "Isinasagawa",
    activeHint: "aprubado, ipinadala, pinoproseso o naipadala",
    done: "Naihatid",
    doneHint: "naihatid o kumpleto",
    closed: "Sarado",
    closedHint: "kinansela, tinanggihan o hindi inaprubahan",
  },
  banner: {
    failed_one: "{{count}} order ang hindi naipadala sa order system mo.",
    failed_other: "{{count}} order ang hindi naipadala sa order system mo.",
    failedBody: "Sinabihan ang kliyente na inaasikaso ng team. I-retry, itala bilang naka-place, o kanselahin.",
    show: "Ipakita",
    waiting_one: "{{count}} order ang naghihintay ng approver.",
    waiting_other: "{{count}} order ang naghihintay ng approver.",
    open: "Buksan ang mga approval",
    syncFailedTitle: "Hindi naipadala ang {{number}} sa order system mo.",
    syncFailedBody: "Sinabihan si {{name}} na inaasikaso ng team. Piliin ang susunod na gagawin.",
    manualTitle: "Naghihintay sa iyo ang order na ito.",
    manualBody: "CSV ang catalogue mo kaya walang awtomatikong ipapadala. I-key in ang order sa system mo, itala dito ang numero nito, o tanggihan ito na may dahilan.",
    cancelRequestedTitle: "Humiling ang kliyente na kanselahin ang order na ito.",
    cancelRequestedBody: "Kapag tinanggap, makakansela ito at masasabihan ang kliyente. Kapag tinanggihan, magpapatuloy ito.",
    cancelled: "Kinansela ang order na ito.",
    declined: "Tinanggihan ng approver ang order na ito.",
    rejected: "Tinanggihan ang order na ito.",
  },
  filters: {
    group: "Filter ng status ng order",
    all: "Lahat",
    search: "Hanapin ang numero ng order, PO o reference",
    searchLabel: "Maghanap ng order",
    organisation: "Organisasyon",
    allOrganisations: "Lahat ng organisasyon",
    clear: "I-clear ang mga filter",
  },
  views: {
    group: "Mga naka-save na view",
    saveCurrent: "I-save ang view na ito",
    saveTitle: "I-save ang view na ito",
    saveBody: "Itinatago ang status, organisasyon at hinahanap mo ngayon, sa browser na ito.",
    name: "Pangalan ng view",
    save: "I-save ang view",
    problem: "Bigyan ng pangalan ang view.",
    remove: "Alisin ang view na {{name}}",
  },
  list: {
    label: "Mga order",
    order: "Order",
    organisation: "Organisasyon",
    lines: "Linya",
    lineCount_one: "{{count}} linya",
    lineCount_other: "{{count}} linya",
    po: "PO",
    total: "Kabuuan",
    status: "Status",
    source: "Ginawa ng",
    created: "Ginawa noong",
    notInSystem: "Wala pa sa system mo",
    individual: "Indibidwal na kliyente",
    showing: "Ipinapakita ang {{shown}} sa {{total}}",
    loadMore: "Magpakita pa",
  },
  empty: {
    title: "Wala pang order",
    body: "Kapag nag-order ang mga kliyente sa chat o web app, o ang staff para sa kanila, lalabas dito ang order kasama ang status nito.",
    filteredTitle: "Walang order na tugma sa mga filter",
    filteredBody: "Subukan ang ibang status, organisasyon o hinahanap.",
  },
  error: { title: "Hindi ito ma-load", body: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago." },
  retry: { sent: "Naipadala ang {{number}} sa order system mo.", stillFailed: "Hindi pa rin naipadala ang {{number}}. Nasa mga connector call nito ang dahilan." },
  markPlaced: {
    title: "Markahang naka-place ang {{number}}",
    description: "Gamitin ito kapag na-key in mo ang order sa sarili mong system at binigyan ka nito ng numero.",
    reference: "Reference sa system mo",
    referenceHint: "Ang numero ng order na ipinapakita ng system mo, halimbawa SO-2026-00880.",
    checked: "Tiningnan ko ang system ko: umiiral ang order at tugma ang mga linya at kabuuan.",
    confirm: "Markahang naka-place",
    done: "Naitala bilang naka-place ang {{number}}.",
    problem: { empty: "Ilagay ang reference na ibinigay ng system sa order.", tooLong: "Gumamit ng {{max}} karakter o mas kaunti.", characters: "Letra, numero at - _ . / # lang ang gamitin.", unchecked: "Kumpirmahin na tiningnan mo ang system mo." },
  },
  cancel: {
    title: "Kanselahin ang {{number}}",
    description: "Masasabihan ang kliyente, at hihilingin sa system mo na kanselahin ang order kung kaya nito.",
    warning: "Hindi na ito mababawi.",
    reason: "Dahilan",
    choose: "Pumili ng dahilan",
    reasons: { credit_hold: "Credit hold sa order system", client_asked: "Humiling ang kliyente na kanselahin", unavailable: "Wala na ang isang item", duplicate: "Dobleng order", other: "Iba pa" },
    note: "Tala para sa record (opsyonal)",
    keep: "Panatilihin ang order",
    confirm: "Kanselahin ang order",
    done: "Kinansela ang {{number}}.",
    problem: "Pumili ng dahilan ng pagkansela.",
  },
  reject: {
    title: "Tanggihan ang {{number}}",
    description: "Tanggihan ang order. Mababasa ng kliyente ang dahilan sa simpleng salita.",
    reason: "Bakit tinanggihan",
    reasons: { out_of_stock: "Ubos na ang stock", price_changed: "Nagbago ang presyo", credit_hold: "Credit hold", invalid_customer: "Hindi naka-set up ang customer sa system", other: "Iba pa" },
    confirm: "Tanggihan ang order",
    done: "Tinanggihan ang {{number}}.",
  },
  cancelRequest: {
    acceptTitle: "Tanggapin ang pagkansela ng {{number}}",
    declineTitle: "Tanggihan ang pagkansela ng {{number}}",
    acceptBody: "Makakansela ang order at masasabihan ang kliyente.",
    declineBody: "Magpapatuloy ang order at masasabihan ang kliyente na hindi ito makakansela.",
    note: "Tala para sa kliyente (opsyonal)",
    noteHint: "Ipapakita sa kliyente kasama ng desisyon.",
    accept: "Tanggapin ang pagkansela",
    decline: "Tanggihan ang pagkansela",
    accepted: "Kinansela ang {{number}}.",
    declined: "Tinanggihan ang hiling na kanselahin ang {{number}}.",
  },
  new: {
    title: "Bagong order para sa kliyente",
    description: "Pareho ang mga tseke sa sariling order ng kliyente: umiiral ang limit, PO rule, stock at price list niya.",
    place: "I-place ang order",
    po: "PO number",
    poHint: "Opsyonal maliban kung hinihingi ng organisasyon.",
    notes: "Mga tala",
    notesHint: "Hanggang {{max}} karakter.",
    rules: "Live ang presyo ng order at kinukumpirma para sa kliyente. Kapag lampas sa limit niya, mapupunta ito sa approver sa halip na sa system mo.",
    done: "Nagawa ang {{number}}.",
    problem: { organisation: "Piliin ang organisasyon.", contact: "Piliin kung para kanino ang order.", lines: "Magdagdag ng kahit isang produkto." },
  },
  newQuote: {
    title: "Bagong quote",
    description: "Maglagay ng quotation para sa kliyente: mga linya, presyo at gaano katagal ang bisa.",
    days: "May bisa (araw)",
    daysHint: "Mula 1 hanggang {{max}} araw.",
    notes: "Mga panloob na tala",
    notesHint: "Ang team lang ang nakakakita nito.",
    send: "Ipadala sa kliyente ngayon",
    sendHint: "Kailangan ng presyo ang bawat linya. Kung hindi, ise-save ang quote at ipapadala kapag napresyuhan na.",
    submit: "I-save ang quote",
    submitSend: "Ipadala ang quote",
    saved: "Na-save ang quote {{number}}.",
    sent: "Naipadala ang quote {{number}}.",
    problem: { contact: "Piliin kung para kanino ang quote.", lines: "Magdagdag ng kahit isang linya.", days: "Maglagay ng buong bilang ng araw mula 1 hanggang {{max}}.", priced: "Bigyan ng presyo ang bawat linya bago ipadala." },
  },
  picker: {
    organisation: "Organisasyon",
    chooseOrganisation: "Pumili ng organisasyon",
    contact: "Contact",
    chooseContact: "Pumili ng contact",
    nobody: "Walang contact ng organisasyong ito na pwedeng mag-order. Payagan muna ang pag-order sa contact.",
  },
  lines: {
    title: "Mga linya",
    empty: "Wala pang linya. Hanapin sa catalogue at magdagdag ng produkto.",
    search: "Hanapin sa catalogue",
    searchHint: "SKU, pangalan o modelo",
    product: "Produkto",
    choose: "Pumili ng produkto",
    noMatch: "Walang tugmang produkto",
    searchFailed: "Hindi nahanap ang catalogue.",
    add: "Idagdag",
    described: "Ilarawan ang item sa salita",
    describedHint: "Para sa wala sa catalogue. Ikaw mismo ang magpepresyo.",
    noSku: "Walang SKU",
    price: "Presyo bawat isa",
    qtyFor: "Dami ng {{name}}",
    priceFor: "Presyo bawat isa ng {{name}}",
    remove: "Alisin ang {{name}}",
  },
  quotes: {
    label: "Mga quote",
    quote: "Quote",
    validUntil: "May bisa hanggang",
    organisation: "Organisasyon",
    contact: "Contact",
    ticket: "Ticket",
    reference: "Reference sa system",
    preview: "Buksan ang quote {{number}}",
    source: { cart: "Mula sa cart", text: "Hiling ng kliyente", staff: "Inilagay ng staff" },
    emptyTitle: "Wala pang quote",
    emptyBody: "Dito lalabas ang mga hiling na quote ng kliyente at mga quotation na inilagay ng staff.",
    drawerTitle: "Quote {{number}}",
    loading: "Quote",
    lines: "Mga linya ng quote",
    byHand: "Pinresyuhan nang mano-mano",
    declinedWhy: "Tinanggihan: {{reason}}",
    orderMade: "Order na ginawa mula sa quote na ito:",
    notes: "Mga panloob na tala",
    saveNotes: "I-save ang mga tala",
    notesSaved: "Na-save ang mga tala.",
    priceTitle: "Bigyan ng presyo ang quote na ito",
    repriceTitle: "Palitan ang mga presyo",
    sendPrices: "Ipadala ang mga presyo sa kliyente",
    priced: "Napresyuhan at naipadala ang quote {{number}}.",
    problem: { price: "Bigyan ng presyo sa piso ang bawat linya, hanggang dalawang decimal.", days: "Ilagay kung ilang araw ang bisa ng mga presyo." },
    decline: "Tanggihan ang quote",
    declineReason: "Dahilan (opsyonal)",
    declineHint: "Sasabihan ang kliyente na tinanggihan ang quote.",
    declined: "Tinanggihan ang quote {{number}}.",
    notFoundTitle: "Hindi mahanap ang quote na ito",
    notFoundBody: "Maaaring naalis na ito. Bumalik sa listahan.",
  },
  approvals: {
    label: "Mga approval ng order",
    filter: "Status ng approval",
    allStatuses: "Lahat ng approval",
    order: "Order",
    requestedBy: "Hiniling ni",
    amount: "Halaga",
    reasons: "Bakit",
    decision: "Desisyon",
    action: "Aksyon",
    side: { client: "Approver ng kliyente", staff: "Approver ng staff" },
    review: "Suriin",
    reviewFor: "Suriin ang approval ng {{number}}",
    decidedAt: "{{when}} ni {{who}}",
    expires: "Mag-e-expire sa {{when}}",
    emptyTitle: "Walang approval",
    emptyBody: "Dito lalabas ang mga order na lampas sa limit ng kliyente o nangangailangan ng desisyon ng staff.",
    nothingTitle: "Walang naghihintay ng approver.",
    nothingBody: "Nag-aapruba ang mga kliyente sa portal nila. Papasok lang ang staff kapag lampas sa staff threshold o sa organisasyong may credit hold.",
    title: "Approval para sa {{number}}",
    loading: "Approval",
    description: "Tingnan ang mga numero at kung bakit hiniling, saka magpasya.",
    lines: "Mga linya ng approval",
    total: "Kabuuan {{total}}",
    repriced: "Binasa ulit ang mga presyo: ang kabuuan ay {{total}} na ngayon ({{percent}}% na mas mataas). Tingnan muna bago aprubahan.",
    outOfStock: "Ubos na ngayon: {{skus}}",
    seen: "Nakita ko na ang mga bagong presyo.",
    note: "Tala",
    noteHint: "Kailangan kapag tinanggihan. Ipapakita sa order.",
    approve: "Aprubahan",
    decline: "Tanggihan",
    approved: "Naaprubahan at naipadala na ang {{number}}.",
    declined: "Tinanggihan ang {{number}}.",
    settledTitle: "Napagpasyahan na",
    settledBody: "May ibang nagpasya na sa approval na ito. Isara ito at i-refresh ang listahan.",
    problem: { unseen: "I-tick na nakita mo na ang mga bagong presyo.", reason: "Sabihin kung bakit mo tinatanggihan." },
  },
  trail: {
    title: "Landas ng approval",
    client: "Ang kliyente",
    confirmed: "Kinumpirma ni {{who}} ang order ({{total}}).",
    asked: "Kailangan ng approver: {{reasons}}.",
    approved: "Inaprubahan ni {{who}}.",
    declined: "Tinanggihan ni {{who}}.",
    expired: "Nag-expire ang approval bago may nagpasya.",
    waiting: "Naghihintay ng approver. Mag-e-expire sa {{when}}.",
    review: "Suriin at magpasya",
    failed: "Hindi ma-load ang landas ng approval.",
  },
  detail: {
    back: "Mga Order",
    loading: "Nilo-load ang order",
    notFoundTitle: "Hindi mahanap ang order na ito",
    notFoundBody: "Tingnan ang numero, o bumalik sa listahan ng mga order.",
    lines_one: "Mga linya · {{count}} item",
    lines_other: "Mga linya · {{count}} item",
    linesLabel: "Mga linya ng order",
    product: "Produkto",
    qty: "Dami",
    unitPrice: "Presyo bawat isa",
    lineTotal: "Kabuuan ng linya",
    shipped_one: "{{count}} ang naipadala",
    shipped_other: "{{count}} ang naipadala",
    listPrice: "List price",
    subtotal: "Subtotal",
    vat: "VAT",
    vatEstimated: "VAT (tantya)",
    vatIncluded: "Kasama ang VAT sa mga presyo.",
    vatExcluded: "Hindi kasama ang VAT sa mga presyo.",
    total: "Kabuuan",
    progress: "Progreso ng order",
    timeline: "Timeline ng status",
    noEvents: "Wala pang nangyayari.",
    staffOnly: "Para sa staff lang",
  },
  progress: { confirmed: "Kumpirmado", approval: "Approval", sent: "Ipinadala sa system mo", processing: "Pinoproseso", shipped: "Naipadala", delivered: "Naihatid", closed: "Sarado", state: { done: "tapos na", current: "isinasagawa", failed: "nabigo", todo: "hindi pa" } },
  event: {
    created: "Nagawa ang order",
    reviewed: "Sinuri ng kliyente",
    price_changed: "Nagbago ang presyo",
    confirmed: "Kinumpirma",
    status_changed: "Nagbago ang status mula {{from}} patungong {{to}}",
    approval_required: "Ipinadala para sa approval",
    queued: "Nakapila para ipadala",
    note: "May idinagdag na tala",
    approval_decided: "Napagpasyahan ang approval",
    submit_attempt: "Sinubukang ipadala sa system mo",
    reconciled: "Tiningnan ang system mo bago mag-retry",
    external_status: "May bagong status mula sa system mo",
    delayed: "Naantala",
  },
  writeback: {
    title: "Pagsulat pabalik sa system mo",
    notSent: "Hindi pa naipapadala",
    placed: "Naka-place",
    waitingApproval: "Walang ipapadala hangga't hindi nagpapasya ang approver.",
    reference: "Reference",
    none: "Wala pa",
    copy: "Kopyahin ang reference",
    retryPlan: "Plano ng retry",
    retryBody: "Tinatanong muna ang system mo sa bawat retry, kaya hindi nagagawa nang dalawang beses ang order.",
    stopped: "Huminto na ang awtomatikong retry. Kailangan ng taong magpasya.",
    calls: "Mga connector call",
    openLog: "Buksan ang call log ng connector",
    time: "Oras",
    operation: "Operation",
    result: "Resulta",
    latency: "Bilis",
    callStatus: { ok: "OK", failed: "Nabigo" },
    noCalls: "Walang naitalang call para sa order na ito sa pinakabagong log ng connector.",
    callsFailed: "Hindi ma-load ang mga connector call.",
    noConnector: "Wala pang naka-set up na connector. Magkonekta sa Commerce profile.",
    noAccess: "Kailangan mo ng access sa mga connector para makita ang mga call para sa order na ito.",
  },
  info: { title: "Order", organisation: "Organisasyon", contact: "Contact", po: "PO number", site: "Lugar ng paghahatid", source: "Ginawa ng", created: "Ginawa noong", requestedDate: "Kailangan bago ang", notes: "Mga tala" },
  confirmation: {
    title: "Record ng kumpirmasyon",
    method: "Paano",
    methods: { card: "Pinindot ng kliyente ang Kumpirmahin", staff_on_behalf: "Staff para sa kliyente" },
    verification: "Na-verify sa pamamagitan ng",
    at: "Kinumpirma noong",
    stepUp: "Step-up code",
    noStepUp: "Hindi kailangan",
    hash: "Hash ng cart",
    copyHash: "Kopyahin ang hash ng cart",
    immutable: "Isang beses lang isinusulat ang record na ito at hindi na mababago.",
    none: "Hindi pa kinukumpirma ng kliyente ang order na ito.",
  },
  fulfilment: { title: "Fulfilment", delayed: "Naantala", tracking: "Tracking", carrier: "Carrier", expected: "Inaasahang paghahatid", invoices: "Mga invoice", checked: "Huling tiningnan" },
  tickets: {
    title: "Mga naka-link na ticket",
    none: "Walang ticket tungkol sa order na ito.",
    failed: "Hindi ma-load ang mga naka-link na ticket.",
    kind: { order_issue: "Problema sa order", requested_via: "Hiniling sa pamamagitan ng" },
    issue: { wrong_item: "Maling item", missing_quantity: "Kulang ang dami", damaged: "Sira", late: "Huli", invoice: "Invoice", other: "Iba pa" },
    create: "Gumawa ng ticket",
    linkExisting: "I-link ang ticket",
    linkTitle: "I-link ang ticket sa {{number}}",
    linkBody: "Dapat sa parehong kliyente ang ticket.",
    number: "Numero ng ticket",
    link: "I-link ang ticket",
    linkProblem: "Maglagay ng numero ng ticket tulad ng TKT-1001.",
    linked: "Naka-link ang ticket na {{ticket}} sa {{number}}.",
  },
  orgTab: { viewAll: "Tingnan lahat", emptyTitle: "Wala pang order", emptyBody: "Dito lalabas ang mga order ng organisasyong ito." },
} as const;
